import { atom } from 'infrastructure/state/jotai.wrapper'
import { INode } from 'shared/types/tree'
import { countsTitle, incorrectCount } from './utility'
import { createIdMap } from '../../version_mapping/utility'
import { getUnitLists } from './contentTree'
import { getGradeId } from '../../utility/TreeHelpers'
import { convertContentTreeToList } from './contentList'

export const updatingAtom = atom(false)
export const treeAtom = atom<INode | undefined>(undefined)

export const idMapAtom = atom((get) => {
  const tree = get(treeAtom)
  if (!tree) return
  return createIdMap(tree)
})

const gradeAtom = atom((get) => {
  const tree = get(treeAtom)
  if (!tree) return 0
  const gradeId = getGradeId(tree)
  if (!gradeId) return 0
  return gradeId - 1
})

export const contentListAtom = atom((get) => {
  const tree = get(treeAtom)

  const grade = get(gradeAtom)
  if (!tree) return []

  const unitLists = getUnitLists(tree)
  return unitLists.flatMap((ul) => convertContentTreeToList(grade, ul))
})

export const requiresUpdateListAtom = atom((get) => {
  const fullList = get(contentListAtom)
  return fullList.filter(({ correctedIndex }) => !!correctedIndex)
})

export const numberIncorrectAtom = atom((get) => {
  const items = get(contentListAtom)
  return incorrectCount(items)
})

export const incorrectCountTitleAtom = atom((get) => {
  const counts = get(numberIncorrectAtom)
  return countsTitle(counts)
})
